export const LEAN_STATUS = Object.freeze({
  WEEKLY_PLAN: 'Will',
  SHOULD: 'Debit',
  COMMITTED: 'Committed',
  RESTRICTED: 'Restricted',
  CAN: 'Can'
});
